import _ from 'lodash'

export const intentIsNotEmptyValueValidation = (value) => {
  const intentObject = JSON.parse(value)
  let res

  if (intentObject.type === 'TEXT') {
    res = !_.isEmpty(intentObject.name)
  }

  if (intentObject.type === 'JSON') {
    res = !_.isEmpty(intentObject.name)
      ? !_.isEmpty(JSON.parse(intentObject.name))
      : false
  }

  if (intentObject.type === 'FLOW') {
    if (!_.isEmpty(intentObject.name)) {
      const flowObject = JSON.parse(intentObject.name)
      res = !_.isEmpty(flowObject.name)
    }
  }

  return res
}
